/** The confirmation round's state (3.3) as the product would show it: a chip beside the visit status. */
import { Chip, Tooltip } from "@mui/material";
import { useBranchClock } from "./branchClock";
import { confirmationLabel, confirmationTone } from "../engine/confirmation";
import { useDemoSelector } from "../store/useDemoStore";
import type { DemoState, VisitAnnotation } from "@caredna-marlin/utils/homeHealthDemo/state";

export function ConfirmationChip({ annotation, channel, sx, state }: { annotation: VisitAnnotation | undefined; channel?: string; sx?: object; state?: Pick<DemoState, "config"> }) {
  const config = useDemoSelector((s) => s.config);
  const reader = state ?? { config };
  const clock = useBranchClock(reader.config.branch.timeZone);
  const label = clock.sentence(confirmationLabel(reader, annotation));
  const tone = confirmationTone(annotation);
  const status = annotation?.round?.status ?? "notSent";
  const color = tone === "confirmed" ? "success" : tone === "needsAttention" ? "error" : tone === "waiting" ? "warning" : "default";
  const round = annotation?.round;
  const tip = [
    round ? "" : "No text has gone out for this visit",
    // Branch time and the user's own clock, not the browser's locale in the browser's zone.
    round?.textedAtIso ? `Texted ${clock.dateTime(round.textedAtIso)}${channel ? ` via ${channel}` : ""}` : "",
    round?.repliedAtIso ? `Replied ${clock.dateTime(round.repliedAtIso)}` : "",
    round?.confirmedAtIso ? `Confirmed ${clock.dateTime(round.confirmedAtIso)}${round.confirmedByPhone ? " — by phone" : ""}` : "",
  ]
    .filter(Boolean)
    .join("\n");
  return (
    <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{tip}</span>}>
      <Chip size="small" color={color} variant={tone === "confirmed" ? "filled" : "outlined"} label={label} sx={{ borderRadius: "4px", fontSize: "13px", fontWeight: 500, ...sx }} data-confirmation={status} />
    </Tooltip>
  );
}
